const BannerAlertModule = {
    namespaced: true,
    state() {
        return {
            AlertBox: true,
        }
    },
};
export default BannerAlertModule;